/* global axios */

import ApiClient from './ApiClient';

class GoogleDriveIntegrationAPI extends ApiClient {
  constructor() {
    super('integrations/google_drive', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, payload);
  }

  listFolders(params = {}) {
    return axios.get(`${this.url}/folders`, { params });
  }

  disconnect() {
    return axios.delete(this.url);
  }
}

export default new GoogleDriveIntegrationAPI();
